/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_View_AllInputs */

const en_directory_rails_view_all = /** @type {(inputs: Directory_Rails_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all`)
};

const zh_directory_rails_view_all = /** @type {(inputs: Directory_Rails_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看全部`)
};

/**
* | output |
* | --- |
* | "View all" |
*
* @param {Directory_Rails_View_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_view_all = /** @type {((inputs?: Directory_Rails_View_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_View_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_view_all(inputs)
	return zh_directory_rails_view_all(inputs)
});
export { directory_rails_view_all as "directory.rails.view_all" }